
import DraggableList from './draggable-list'
import {
  INNER_FIELD_PROPS,
  COLUMN_WIDTHS
} from '../constants'
import {
  findNextMatch,
  setAllShow,
  flattenFields,
  calcCheckStatus,
  setFieldShow,
  moveField
} from '../data/field-operations'

export default {
  components: { DraggableList },
  props: {
    fields: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      searchKey: '',
      activeKey: '',
      checkAll: false,
      isIndeterminate: false,
    }
  },
  watch: {
    fields: {
      immediate: true,
      handler() {
        this.updateCheckAllStatus()
      }
    },
    searchKey(val) {
      if (val) {
        this.activeKey = findNextMatch(this.fields, val, '')
      } else {
        this.activeKey = ''
      }
    },
    activeKey(val) {
      if (val) {
        this.$nextTick(() => {
          this.scrollToActiveRow()
        })
      }
    }
  },
  methods: {
    scrollToActiveRow() {
      const activeRow = this.$el.querySelector('.kye-field-settings-row.is-active')
      if (activeRow) {
        activeRow.scrollIntoView({ block: 'center', behavior: 'smooth' })
      }
    },
    handleSearchInput(val) {
      this.searchKey = val
    },
    handleSearchEnter() {
      if (!this.searchKey) return
      this.activeKey = findNextMatch(this.fields, this.searchKey, this.activeKey)
    },
    handleNext() {
      if (!this.searchKey) return
      this.activeKey = findNextMatch(this.fields, this.searchKey, this.activeKey)
    },
    updateCheckAllStatus() {
      const allFields = flattenFields(this.fields)
      const status = calcCheckStatus(allFields)
      this.checkAll = status.checkAll
      this.isIndeterminate = status.isIndeterminate
    },
    handleCheckAll(val) {
      setAllShow(this.fields, val)
      this.updateCheckAllStatus()
    },
    handleShowChange(val, row) {
      setFieldShow(this.fields, row, val)
      this.updateCheckAllStatus()
    },
    handleFixedChange(val, row) {
      row[INNER_FIELD_PROPS.FIXED] = val
    },
    handleMove(val, row) {
      const targetIndex = parseInt(val, 10)
      if (isNaN(targetIndex) || targetIndex < 1) return
      moveField(this.fields, row, targetIndex)
    }
  },
  render() {
    const { searchKey, checkAll, isIndeterminate, fields } = this
    const warpClass = 'kye-field-settings-panel'
    const headerClass = 'kye-field-settings-panel-header'
    const headerCellClass = 'kye-field-settings-panel-header-cell'
    const contentClass = 'kye-field-settings-panel-content kye-scrollbar'

    return (
      <div class={warpClass}>
        {/* 搜索框 */}
        <div class="kye-field-settings-panel-search">
          <el-input
            value={searchKey}
            onInput={this.handleSearchInput}
            nativeOnKeyup={e => { if (e.key === 'Enter') this.handleSearchEnter() }}
            clearable
            placeholder="输入列名后可定位到指定项"
          >
            <el-button slot="append" onClick={this.handleNext}>下一个</el-button>
          </el-input>
        </div>
        {/* 表头 */}
        <div class={headerClass}>
          <div class={headerCellClass + ' is-check'} style={{ width: COLUMN_WIDTHS.CHECK }}>
            <el-checkbox
              value={checkAll}
              indeterminate={isIndeterminate}
              onInput={this.handleCheckAll}
            >
              全选
            </el-checkbox>
          </div>
          <div class={headerCellClass + ' is-label'}>字段名称(上下拖动排序)</div>
          <div class={headerCellClass + ' is-fixed'} style={{ width: COLUMN_WIDTHS.FIXED }}>固定列</div>
          <div class={headerCellClass + ' is-move'} style={{ width: COLUMN_WIDTHS.MOVE }}>输入序号移动</div>
        </div>
        {/* 字段列表 */}
        <div class={contentClass}>
          <DraggableList
            fields={fields}
            level={0}
            activeKey={this.activeKey}
            onShowChange={this.handleShowChange}
            onFixedChange={this.handleFixedChange}
            onMove={this.handleMove}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-field-settings/components/field-panel.js